import { Box, Typography } from "@mui/material";
import { userPages } from "../TracksPageComponents/types";
import { useContext, useEffect, useState } from "react";
import LockIcon from "@mui/icons-material/Lock";
import { TalkJsContext, TalkJsContextInterface } from "../../contexts";
import {
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../contexts";
import { useAuth0 } from "@auth0/auth0-react";
import { styles } from "../TracksPageComponents/styles";
import { useNavigate, useLocation } from "react-router-dom";
import { DrawerPagesProps } from "./types";

export const DrawerPages: React.FC<DrawerPagesProps> = ({
  currentUser,
  currentPage,
  setCurrentPage,
  session,
  setInbox,
}) => {
  const { loginWithRedirect } = useAuth0();
  const talkJsContext = useContext<TalkJsContextInterface>(TalkJsContext);
  const { isEnterpriseAccount } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [isProjectsPage, setIsProjectsPage] = useState(false);

  useEffect(() => {
    const isProjectPage =
      window.location.pathname.includes("project") &&
      !window.location.pathname.includes("undefined");
    setIsProjectsPage(isProjectPage);

    const currentPath = window.location.pathname;
    const matchedPage = userPages.find(
      (page) =>
        currentPath === page.route ||
        (page.route !== "/" && currentPath.startsWith(page.route))
    );

    if (matchedPage && matchedPage.name !== currentPage) {
      setCurrentPage(matchedPage.name);
    }
  }, [location.pathname, setCurrentPage, currentPage]);

  return (
    <>
      <Box sx={{ marginTop: "20px" }}>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          {userPages.map((page, i) => {
            const showProjectsPage = currentUser && isEnterpriseAccount;
            if (
              (page.name === "Projects" || page.name === "Dashboard") &&
              !showProjectsPage
            ) {
              return null;
            }

            const isCurrentRoute =
              location.pathname === page.route ||
              (page.route !== "/" && location.pathname.startsWith(page.route));

            const isHighlighted =
              (page.name === currentPage && !isProjectsPage) ||
              (page.name === "Projects" && isProjectsPage) ||
              (page.name === "Dashboard" && isCurrentRoute);

            return (
              <Box
                sx={{
                  ...styles.pageNameContainer,
                  ...{
                    display:
                      talkJsContext.isChatOpen && page.name === "Messages"
                        ? "none"
                        : "flex",
                    backgroundColor: isHighlighted ? "#1F242F" : "",
                  },
                }}
                key={i}
                onClick={() => {
                  if (currentUser || page.name === "Explore") {
                    if (page.name !== "Messages") {
                      setCurrentPage(page.name);
                      if(page.name === "Hub"){
                        window.location.href = page.route
                      }else{
                        navigate(page.route);
                      } 
                    } else {
                      if (session && setInbox) {
                        const talkInbox = session.createInbox();
                        setInbox(talkInbox);
                        talkJsContext.setIsChatOpen(true);
                      }
                    }
                  } else {
                    loginWithRedirect({
                      appState: { returnTo: "/my-tracks" },
                      authorizationParams: { screen_hint: "signup" },
                    });
                  }
                }}
              >
                <img
                  style={{ filter: "contrast(0%)", width: "10%" }}
                  src={page.iconPath}
                  alt="icon"
                />
                <Typography
                  sx={{ fontSize: "14px", fontWeight: 400, width: "90%" }}
                >
                  {page.name}
                </Typography>
                {!currentUser && page.name !== "Explore" ? (
                  <LockIcon sx={{ fontSize: "18px" }} />
                ) : null}
              </Box>
            );
          })}
        </Box>
      </Box>
    </>
  );
};
